module.exports = __webpack_public_path__ + "static/media/15_l_krasra_28.02_85.47.ea86a1cf.png";